(function () {
  var active = null;

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function nextFrames(count) {
    return new Promise(function (resolve) {
      function step(left) {
        if (left <= 0) {
          resolve();
          return;
        }
        window.requestAnimationFrame(function () {
          step(left - 1);
        });
      }
      step(count);
    });
  }

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function scenesFor(root, deck) {
    return Array.prototype.filter.call(root.querySelectorAll('[data-round3-scene]'), function (scene) {
      return scene.getAttribute('data-deck') === deck;
    });
  }

  function setFlipped(scene, flipped) {
    if (!scene) return;
    scene.classList.toggle('is-flipped', flipped);
    scene.setAttribute('aria-pressed', flipped ? 'true' : 'false');
  }

  function makeImg(src) {
    var img = document.createElement('img');
    img.className = 'jojo-campaign-round3-overlay__img';
    img.src = src;
    img.alt = '';
    img.loading = 'eager';
    img.draggable = false;
    return img;
  }

  function deckEl(root, name) {
    return root.querySelector('[data-round3-deck="' + name + '"]');
  }

  function isFlipped(scene) {
    return scene.classList.contains('is-flipped');
  }

  function sideReady(root, deck) {
    var scenes = scenesFor(root, deck);
    return scenes.length === 3 && scenes.every(isFlipped);
  }

  function sceneAttr(scene, name) {
    var desktop = window.matchMedia('(min-width: 750px)').matches;
    var mb = scene.getAttribute(name + '-mb');
    var pc = scene.getAttribute(name);
    if (desktop) return pc || mb || '';
    return mb || pc || '';
  }

  function buildOverlay(root, scenes, revealSrc) {
    var overlay = document.createElement('div');
    overlay.className = 'jojo-campaign-round3-overlay';

    var sample = scenes[0] && (scenes[0].querySelector('.jojo-campaign-round3__frame') || scenes[0]);
    var rect = sample ? sample.getBoundingClientRect() : { width: 160, height: 110 };
    var cardWidth = rect.width || 160;
    var cardHeight = rect.height || 110;
    var gap = Math.max(12, cardWidth * 0.08);
    var total = scenes.length * cardWidth + Math.max(0, scenes.length - 1) * gap;
    var maxWidth = window.innerWidth * 0.9;
    if (total > maxWidth && total > 0) {
      var scale = maxWidth / total;
      cardWidth *= scale;
      cardHeight *= scale;
      gap *= scale;
      total = maxWidth;
    }
    var startX = (window.innerWidth - total) / 2;
    var top = (window.innerHeight - cardHeight) / 2;
    var midIndex = Math.min(1, scenes.length - 1);
    var midLeft = startX + midIndex * (cardWidth + gap);
    var midCx = midLeft + cardWidth / 2;
    var midCy = top + cardHeight / 2;

    scenes.forEach(function (scene, index) {
      var left = startX + index * (cardWidth + gap);
      var ghost = document.createElement('div');
      ghost.className = 'jojo-campaign-round3-overlay__ghost';
      ghost.style.left = left + 'px';
      ghost.style.top = top + 'px';
      ghost.style.width = cardWidth + 'px';
      ghost.style.height = cardHeight + 'px';
      ghost.style.setProperty('--dx', midCx - (left + cardWidth / 2) + 'px');
      ghost.style.setProperty('--dy', midCy - (top + cardHeight / 2) + 'px');
      ghost.dataset.slot = String(index);
      var src = sceneAttr(scene, 'data-image-back');
      if (src) ghost.appendChild(makeImg(src));
      overlay.appendChild(ghost);
    });

    var fan = document.createElement('div');
    fan.className = 'jojo-campaign-round3-overlay__fan';
    fan.hidden = true;
    var cardBack = root.getAttribute('data-card-back');

    for (var i = 0; i < 5; i += 1) {
      var card = document.createElement('div');
      card.className = 'jojo-campaign-round3-overlay__card';
      card.dataset.slot = String(i);
      card.setAttribute('role', 'button');
      card.tabIndex = 0;
      card.setAttribute('aria-label', 'カードを選ぶ');

      var scaler = document.createElement('div');
      scaler.className = 'jojo-campaign-round3-overlay__scaler';
      var flip = document.createElement('div');
      flip.className = 'jojo-campaign-round3-overlay__flip';

      var gold = document.createElement('div');
      gold.className = 'jojo-campaign-round3-overlay__face jojo-campaign-round3-overlay__face--gold';
      if (cardBack) gold.appendChild(makeImg(cardBack));

      var reveal = document.createElement('div');
      reveal.className = 'jojo-campaign-round3-overlay__face jojo-campaign-round3-overlay__face--reveal';
      if (revealSrc) reveal.appendChild(makeImg(revealSrc));

      flip.appendChild(gold);
      flip.appendChild(reveal);
      scaler.appendChild(flip);
      card.appendChild(scaler);
      fan.appendChild(card);
    }

    overlay.appendChild(fan);
    return overlay;
  }

  function clearOverlay() {
    if (!active) return;
    active.remove();
    active = null;
    document.documentElement.classList.remove('jojo-campaign-round3-lock');
  }

  function waitForChoice(overlay) {
    return new Promise(function (resolve) {
      var cards = overlay.querySelectorAll('.jojo-campaign-round3-overlay__card');

      function choose(card) {
        cards.forEach(function (item) {
          item.removeEventListener('click', onClick);
          item.removeEventListener('keydown', onKey);
        });
        overlay.classList.remove('is-choosing');
        card.classList.add('is-chosen');
        overlay.classList.add('is-picked');
        resolve();
      }

      function onClick(event) {
        choose(event.currentTarget);
      }

      function onKey(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        choose(event.currentTarget);
      }

      cards.forEach(function (card) {
        card.addEventListener('click', onClick);
        card.addEventListener('keydown', onKey);
      });
      overlay.classList.add('is-choosing');
    });
  }

  function markDrawn(root, deckName) {
    var deck = deckEl(root, deckName);
    if (deck) deck.classList.add('is-drawn');
  }

  function play(root, deckName) {
    if (root.dataset.round3Playing === 'true') return;

    var deck = deckEl(root, deckName);
    var scenes = scenesFor(root, deckName);
    if (!deck || deck.classList.contains('is-drawn') || !scenes.length) return;

    if (reducedMotion()) {
      markDrawn(root, deckName);
      return;
    }

    root.dataset.round3Playing = 'true';
    clearOverlay();
    var revealSrc = deck.getAttribute('data-result') || '';
    var overlay = buildOverlay(root, scenes, revealSrc);
    active = overlay;
    document.body.appendChild(overlay);
    document.documentElement.classList.add('jojo-campaign-round3-lock');

    var fan = overlay.querySelector('.jojo-campaign-round3-overlay__fan');

    nextFrames(2)
      .then(function () {
        overlay.classList.add('is-in');
        return wait(1800);
      })
      .then(function () {
        overlay.querySelectorAll('.jojo-campaign-round3-overlay__ghost').forEach(function (ghost) {
          ghost.classList.add('is-play');
        });
        return wait(600);
      })
      .then(function () {
        overlay.querySelectorAll('.jojo-campaign-round3-overlay__ghost').forEach(function (ghost) {
          ghost.remove();
        });
      })
      .then(function () {
        fan.hidden = false;
        return wait(200);
      })
      .then(function () {
        overlay.classList.add('is-fan');
        return wait(600);
      })
      .then(function () {
        return waitForChoice(overlay);
      })
      .then(function () {
        return wait(600);
      })
      .then(function () {
        overlay.classList.add('is-centered');
        return wait(700);
      })
      .then(function () {
        var chosen = overlay.querySelector('.jojo-campaign-round3-overlay__card.is-chosen');
        if (chosen) chosen.classList.add('is-shut');
        return wait(300);
      })
      .then(function () {
        var chosen = overlay.querySelector('.jojo-campaign-round3-overlay__card.is-chosen');
        if (chosen) chosen.classList.add('is-swapped');
        return wait(20);
      })
      .then(function () {
        var chosen = overlay.querySelector('.jojo-campaign-round3-overlay__card.is-chosen');
        if (chosen) {
          chosen.classList.remove('is-shut');
          chosen.classList.add('is-open');
        }
        return wait(300);
      })
      .then(function () {
        return wait(800);
      })
      .then(function () {
        overlay.classList.add('is-closing');
        return wait(300);
      })
      .then(function () {
        if (active === overlay) clearOverlay();
        markDrawn(root, deckName);
        root.dataset.round3Playing = 'false';
      })
      .catch(function () {
        if (active === overlay) clearOverlay();
        root.dataset.round3Playing = 'false';
      });
  }

  function initRound3(root) {
    if (!root || root.dataset.round3Ready === 'true') return;
    root.dataset.round3Ready = 'true';

    root.addEventListener('click', function (event) {
      if (root.dataset.round3Playing === 'true') return;

      var scene = event.target.closest('[data-round3-scene]');
      if (!scene || !root.contains(scene)) return;

      setFlipped(scene, !scene.classList.contains('is-flipped'));

      var clickedDeck = scene.getAttribute('data-deck');
      var otherDeck = clickedDeck === 'jonathan' ? 'dio' : 'jonathan';
      var order = [clickedDeck, otherDeck];

      for (var i = 0; i < order.length; i += 1) {
        var name = order[i];
        var deck = deckEl(root, name);
        if (sideReady(root, name) && deck && !deck.classList.contains('is-drawn')) {
          play(root, name);
          return;
        }
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-jojo-campaign-round3]').forEach(initRound3);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-jojo-campaign-round3]')
      : null;
    if (!root) return;
    clearOverlay();
    root.dataset.round3Ready = 'false';
    root.dataset.round3Playing = 'false';
    initRound3(root);
  });

  document.addEventListener('shopify:section:unload', function () {
    clearOverlay();
  });
})();
